"use client";

import { Play } from "lucide-react";
import Image from "next/image";
import { useState } from "react";

import { VideoModal } from "~/components/VideoModal";
import { Button } from "~/components/ui/button";
import { Card, CardContent } from "~/components/ui/card";
import { type FragmentOf, readFragment } from "~/lib/graphql";

import * as fragment from "./graphql";

export function VideoList(props: {
  record: FragmentOf<typeof fragment.VideoListFragment>;
}) {
  const record = readFragment(fragment.VideoListFragment, props.record);
  // console.log(record);

  const videos = record.video;
  const [selectedVideo, setSelectedVideo] = useState<string | null>(null);

  return (
    <section className="container mx-auto mb-16">
      {/* <h2 className="mb-8 text-3xl font-bold text-blue-800">Educational Videos</h2> */}
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {videos.map((video) => (
          <Card
            key={video.id}
            className="group overflow-hidden transition-shadow hover:shadow-lg"
          >
            <CardContent className="p-0">
              <div
                className="relative aspect-video cursor-pointer overflow-hidden"
                onClick={() => setSelectedVideo(video.video.providerUid)}
              >
                <Image
                  src={`${video.video.thumbnailUrl}`}
                  alt={String(video.title || video.video.title || "")}
                  fill={true}
                  className="object-cover transition-transform group-hover:scale-105"
                />
                <div className="absolute inset-0 flex items-center justify-center bg-black/30 transition-colors group-hover:bg-black/40">
                  <Button
                    size="icon"
                    variant="outline"
                    className="h-12 w-12 rounded-full border-white/40 bg-white/20 backdrop-blur-sm hover:bg-white/30"
                  >
                    <Play className="h-12 w-12 text-white" />
                  </Button>
                </div>
              </div>
              {video?.title ||
                (video.abstract && (
                  <div className="p-4">
                    {video?.title && (
                      <h3 className="mb-2 font-semibold text-blue-800">{video.title}</h3>
                    )}

                    {video?.abstract && (
                      <p className="text-sm text-slate-600">{video.abstract}</p>
                    )}
                  </div>
                ))}
            </CardContent>
          </Card>
        ))}
      </div>
      {selectedVideo && (
        <VideoModal videoId={selectedVideo} onClose={() => setSelectedVideo(null)} />
      )}
    </section>
  );
}
